/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export type ComponentImageType = string;
export type ComponentImageIdsByName = Record<string, number[]>;

export function normalizeComponentImageType(name: unknown,
                                            imageTypes: readonly ComponentImageType[]): ComponentImageType {
    const normalizedName = typeof name === 'string' ? name.trim().toLowerCase() : '';
    return imageTypes.find(imageType => imageType.toLowerCase() === normalizedName)
        ?? imageTypes.find(imageType => imageType.toLowerCase() === 'general')
        ?? 'General';
}

export function getComponentImageIdsForType(imageIdsByName: unknown, imageType: ComponentImageType,
                                            imageTypes: readonly ComponentImageType[]): number[] {
    if (imageIdsByName == null || typeof imageIdsByName !== 'object' || Array.isArray(imageIdsByName)) {
        return [];
    }
    return Object.entries(imageIdsByName)
                 .filter(([name, fileIds]) =>
                     normalizeComponentImageType(name, imageTypes) === imageType && Array.isArray(fileIds))
                 .flatMap(([, fileIds]) => [...fileIds] as number[]);
}

export function setComponentImageIdsForType(imageIdsByName: unknown, imageType: ComponentImageType,
                                            fileIds: number[],
                                            imageTypes: readonly ComponentImageType[]): ComponentImageIdsByName {
    const results: ComponentImageIdsByName = {};
    if (imageIdsByName != null && typeof imageIdsByName === 'object' && !Array.isArray(imageIdsByName)) {
        for (const [name, existingFileIds] of Object.entries(imageIdsByName)) {
            const existingImageType = normalizeComponentImageType(name, imageTypes);
            if (existingImageType !== imageType && Array.isArray(existingFileIds)) {
                (results[existingImageType] ??= []).push(...existingFileIds as number[]);
            }
        }
    }
    if (fileIds.length > 0) {
        results[imageType] = [...fileIds];
    }
    return results;
}
